var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLinkOrange = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5H17.5V17V12.5H18.5V17C18.5 17.3978 18.342 17.7794 18.0607 18.0607C17.7794 18.342 17.3978 18.5 17 18.5H3C2.60218 18.5 2.22064 18.342 1.93934 18.0607C1.65804 17.7794 1.5 17.3978 1.5 17V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H7.5V2.5H3H2.5V3V17V17.5H3H17Z",
    stroke: "#EC6A4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6436 3.93645L12.2071 1.5H18.5V7.79289L16.0636 5.35645L15.71 5.00289L15.3564 5.35645L9.98 10.7329L9.2671 10.02L14.6436 4.64355L14.9971 4.29L14.6436 3.93645Z",
    stroke: "#EC6A4E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkOrange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link_orange.3a806c88.svg";
export { ForwardRef as ReactComponent };